import { render, staticRenderFns } from "./LabsTable.vue?vue&type=template&id=0960890f&"
import script from "./LabsTable.vue?vue&type=script&lang=js&"
export * from "./LabsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports